import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import dayjs from 'dayjs'; // Import dayjs for date handling

const ClassProfile = () => {
    const classId = window.location.pathname.split('/').pop(); // Extract class ID from URL
    const [students, setStudents] = useState([]); // List of students
    const [className, setClassName] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date()); // Selected date on the calendar
    const [loading, setLoading] = useState(false);
    const [allClasses, setAllClasses] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [newClassId, setNewClassId] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [nameModalOpen, setNameModalOpen] = useState(false);
    const [newStudentName, setNewStudentName] = useState('');
    const [summary, setSummary] = useState([]);
    const [recordModalOpen, setRecordModalOpen] = useState(false);
    const [recordStartDate, setRecordStartDate] = useState('');
    const [recordEndDate, setRecordEndDate] = useState('');
    const [recordStatus, setRecordStatus] = useState(1);
    const [recordRemarks, setRecordRemarks] = useState('');
    const [mcReasons, setMCReasons] = useState([]);
    const [selectedMCReason, setSelectedMCReason] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [studentToDelete, setStudentToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);

    const openDeleteModal = (student) => {
        setStudentToDelete(student);
        setDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
        setStudentToDelete(null);
    };

    useEffect(() => {
        getClassName();
        fetchAllClasses();
        getMCReasons();
    }, [classId]);

    useEffect(() => {
        console.log(selectedMCReason)
    }, [selectedMCReason]);
    const openRecordAttendanceModal = (student) => {
        setSelectedStudent(student);
        setRecordStartDate(dayjs(selectedDate).format('YYYY-MM-DD'));
        setRecordEndDate(dayjs(selectedDate).format('YYYY-MM-DD'));
        setRecordStatus(1);
        setRecordRemarks('');
        setRecordModalOpen(true);
    };


    const openNameModal = (student) => {
        setSelectedStudent(student);
        setNewStudentName(student.first_name);
        setNameModalOpen(true);
    };

    const closeNameModal = () => {
        setSelectedStudent(null);
        setNewStudentName('');
        setNameModalOpen(false);
    };
    const updateStudentName = async () => {
        if (!selectedStudent || !newStudentName.trim()) {
            toast.error("Please enter a valid name.", { autoClose: 5000 });
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                '/portal/modifyStudentName',
                { student_id: selectedStudent.student_uuid, new_name: newStudentName.trim() },
                { headers }
            );

            if (response.data.response_code === 1000) {
                toast.success("Student name updated successfully!", { autoClose: 5000 });
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
                closeNameModal();
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.log(error)
            toast.error(`Error updating student name ${error}`, { autoClose: 5000 });
        }
    };
    const getClassName = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                `/school/classID`,
                { class_id: classId }, // Include class_id and date in the body
                { headers }
            );

            if (response.data.response_code === 1000) {
                setClassName(response.data.data.class_name || ''); // Update students data
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error fetching class:', error);
            toast.error("Error fetching class name", { autoClose: 5000 });
        } finally {

        }

    }
    const fetchAllClasses = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.get(`/school/classes`, { headers });
            if (response.data.response_code === 1000) {
                setAllClasses(response.data.data || []);
            } else {
                toast.error("Failed to fetch class list", { autoClose: 5000 });
            }
        } catch (error) {
            console.error("Error fetching class list:", error);
            toast.error("Error fetching class list", { autoClose: 5000 });
        }
    };
    const fetchStudentsAttendanceSummary = async (date) => {
        setLoading(true);
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        const formattedDate = dayjs(date).format('YYYY-MM-DD'); // Format as YYYY-MM-DD

        try {
            const response = await API.post(
                `/attendance/attendanceByClassSummary`,
                { class_id: classId, date: formattedDate }, // Include class_id and date in the body
                { headers }
            );

            if (response.data.response_code === 1000) {
                setSummary(response.data.data || []); // Update students data
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error("Error fetching students", { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };
    // Fetch students based on class and selected date
    const fetchStudentsAttendanceDetail = async (date) => {
        setLoading(true);
        setStudents([]);
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        const formattedDate = dayjs(date).format('YYYY-MM-DD'); // Format as YYYY-MM-DD

        try {
            const response = await API.post(
                `/attendance/attendanceByClassDetail`,
                { class_id: classId, date: formattedDate }, // Include class_id and date in the body
                { headers }
            );

            if (response.data.response_code === 1000) {
                setStudents(response.data.data || []); // Update students data
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error("Error fetching students", { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };
    const confirmDeleteStudent = async () => {
        if (!studentToDelete) return;
        setDeleting(true); // <--- Add this

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        try {
            const response = await API.post(
                '/portal/delete',
                { student_id: studentToDelete.student_uuid },
                { headers }
            );
            if (response.data.code === 1000 || response.data.response_code === 1000) {
                toast.success(response.data.message || "Student deleted successfully!", { autoClose: 5000 });
                // Refresh data after deletion
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
            } else {
                toast.error(response.data.message || "Failed to delete student", { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Delete student error:', error);
            toast.error("Error deleting student", { autoClose: 5000 });
        } finally {
            setDeleting(false);
            closeDeleteModal();
        }
    };


    useEffect(() => {
        fetchStudentsAttendanceDetail(selectedDate);
        fetchStudentsAttendanceSummary(selectedDate);
    }, [classId, selectedDate]);


    // Highlight dates with attendance records
    const tileContent = ({ date, view }) => {
        if (view === 'month') {
            const formattedDate = dayjs(date).format('YYYY-MM-DD');
            const record = summary?.date_summary?.find(item => item.date === formattedDate);
            if (record && record.total_students > 0) {
                return (
                    <div>
                        {record.total_present}/{record.total_students}
                    </div>
                );
            }
        }
        return null;
    };

    // Group and filter detailed records by student_uuid and selected date
    const formattedSelectedDate = dayjs(selectedDate).format('YYYY-MM-DD');
    const groupedRecords = students.detailed_records?.reduce((acc, record) => {
        const studentId = record.student_uuid;

        // Initialize the student record if not already present
        if (!acc[studentId]) {
            acc[studentId] = {
                profile_pic: record.profile_pic,
                student_status: record.student_status,
                student_uuid: record.student_uuid,
                first_name: record.first_name,
                moeis_name: record.moeis_name,
                attendance: [], // Store attendance details
            };
        }

        // Only include records matching the selected date
        if (record.date === formattedSelectedDate) {
            acc[studentId].attendance.push({
                profile_pic: record.profile_pic,
                student_status: record.student_status,
                date: record.date,
                status: record.status,
                check_in_time: record.check_in_time,
                check_in_gate: record.check_in_gate,
                check_out_time: record.check_out_time,
                check_out_gate: record.check_out_gate,
                check_in_image_url: record.check_in_image_url || null,
                check_out_image_url: record.check_out_image_url || null,
                letter_attachment_url: record.letter_attachment_url || null,
                remarks: record.remarks,
            });
        }

        return acc;
    }, {});

    const notifyParent = async (studentUuid) => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        try {
            const response = await API.post(
                `/attendance/notifyParent`,
                JSON.stringify({ student_id: studentUuid }), // Pass the student UUID and date
                { headers }
            );

            if (response.data.response_code === 1000) {
                toast.success("Parent notified successfully", { autoClose: 5000 });
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {

            toast.error("Error notifying parent", { autoClose: 5000 });
        }
    };
    const openUpdateClassModal = (student) => {
        setSelectedStudent(student);
        setModalOpen(true);
    };
    const closeModal = () => {
        setSelectedStudent(null);
        setNewClassId('');
        setModalOpen(false);
    };
    // 2. getMCReasons function INSIDE your component
    const getMCReasons = async () => {
        const url = "https://api.schoolpay.tech/attendance/absenceReason";
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            const responseJSON = await response.json();

            if (responseJSON.response_code === 1000) {
                const reasons = responseJSON.data.map((reason) => ({
                    label: reason.name + (reason.sub_reason ? " - " + reason.sub_reason : ""),
                    value: reason.reason_id,
                }));
                setMCReasons(reasons);
            } else {
                console.error("Failed to fetch MC reasons:", responseJSON.message);
            }
        } catch (error) {
            console.error("Error fetching MC reasons:", error);
        }
    };
    const updateStudentClass = async () => {
        if (!selectedStudent || !newClassId) {
            toast.error("Please select a new class.", { autoClose: 5000 });
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                `/portal/modifyClass`,
                { student_id: selectedStudent.student_uuid, new_class_id: newClassId },
                { headers }
            );

            if (response.data.response_code === 1000) {
                toast.success("Student class updated successfully!", { autoClose: 5000 });
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
                closeModal();
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error updating student class:', error);
            toast.error("Error updating student class", { autoClose: 5000 });
        }
    };
    const submitManualAttendance = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        let payload = {
            class_id: classId,
            student_uuid: selectedStudent.student_uuid,
            start_date: recordStartDate,
            end_date: recordEndDate || recordStartDate,
            status: Number(recordStatus),
        };

        if (Number(recordStatus) === 0) {
            // MC required for Absent
            if (!selectedMCReason) {
                toast.error("Please select a MC/Absence reason.", { autoClose: 5000 });
                return;
            }
            payload.remarks = selectedMCReason.label;
            payload.reason_type = selectedMCReason.value;
        } else {
            // Remarks for present, but NOT MC reason!
            payload.remarks = recordRemarks;
            payload.reason_type = "";
        }

        setLoading(true);

        try {
            const response = await API.post('/attendance/teacher/record', payload, { headers });
            if (response.data.response_code === 1000) {
                toast.success(response.data.message, { autoClose: 5000 });
                setRecordModalOpen(false);
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error(error.message, { autoClose: 5000 });

        } finally {
            setLoading(false);
        }
    };


    const getStatusChip = (status) => {
        switch (status) {
            case '0':
                return (
                    <span
                        style={{
                            backgroundColor: '#f8d7da',
                            color: '#721c24',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Unrecorded
                    </span>
                );
            case '3':
                return (
                    <span
                        style={{
                            backgroundColor: '#ffdddd',
                            color: '#b20000',
                            padding: '4px 8px',
                            borderRadius: '16px',
                            fontWeight: 'bold',
                            border: '2px solid #ff0000',
                            fontSize: '1rem',
                            letterSpacing: '0.02em',
                            boxShadow: '0 0 6px #ff000080',
                            display: 'inline-flex',
                            alignItems: 'center',
                            animation: 'alarmPulse 1s infinite alternate'
                        }}
                    >
                        <span style={{ marginRight: 8, fontSize: '1.3em' }}>⚠️</span>
                        Requires Re-record
                        <style>
                            {`
                        @keyframes alarmPulse {
                            from { box-shadow: 0 0 10px #ff000080; }
                            to   { box-shadow: 0 0 30px #ff0000, 0 0 10px #ff000080; }
                        }
                        `}
                        </style>
                    </span>

                );
            case '4':
                return (
                    <span
                        style={{
                            backgroundColor: '#fff3cd',
                            color: '#155724',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Parents not linked
                    </span>
                );
            case '2':
                return (
                    <span
                        style={{
                            backgroundColor: '#d4edda',
                            color: '#155724',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Completed
                    </span>
                );
            default:
                return (
                    <span
                        style={{
                            backgroundColor: '#f8f9fa',
                            color: '#6c757d',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Unknown
                    </span>
                );
        }
    };
    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="card">
                            <div className="card-header">
                                <h4>Class Attendance for {className}</h4>
                            </div>
                            <div className="card-body">
                                <Calendar
                                    onChange={(date) => {
                                        setLoading(true);
                                        setSelectedDate(date);
                                        // Manually trigger fetches with the new date instead of waiting for useEffect
                                        fetchStudentsAttendanceDetail(date);
                                        fetchStudentsAttendanceSummary(date);
                                    }}
                                    value={selectedDate} // Convert string to Date object
                                    tileContent={tileContent} // Highlight dates
                                    tileDisabled={({ date, view }) =>
                                        view === 'month' && (date.getDay() === 0 || date.getDay() === 6) // Disable Sunday (0) & Saturday (6)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        {loading ? (
                            <p>Loading students...</p>
                        ) : groupedRecords && Object.keys(groupedRecords).length > 0 ? (
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th></th>
                                        <th>Profile</th>
                                        <th>Student Status</th>
                                        <th>Attendance Timeline</th>
                                        <th>Notify Parent</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.values(groupedRecords).map((student, index) => (

                                        <tr key={student.student_uuid}>
                                            <td>{index + 1}</td>
                                            <td>{student.first_name}
                                                <br />
                                                {student.first_name !== student.moeis_name && (
                                                    <div className='text-gray'>MOEIS: {student.moeis_name}</div>
                                                )}
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => openNameModal(student)}
                                                >
                                                    Update Name
                                                </button>
                                            </td>
                                            <td>
                                                {student.profile_pic ? <img
                                                    src={student.profile_pic}  // Use the profile_pic URL here
                                                    alt={`${student.first_name}'s Profile`}
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        borderRadius: '50%',
                                                        marginLeft: '10px',  // Add some space between name and profile picture
                                                        objectFit: 'cover',  // Ensures the image fits within the 50x50 box
                                                    }}
                                                /> : null}
                                            </td>
                                            <td>
                                                {getStatusChip(student.student_status)} {/* Display the chip */}
                                            </td>
                                            <td>
                                                {/* Render statuses for the student */}
                                                {student.attendance.map((att, i) => (
                                                    <div
                                                        key={i}
                                                        className="mb-2"
                                                        style={{
                                                            display: 'inline-block',
                                                            padding: '5px 10px',
                                                            borderRadius: '12px',
                                                            fontWeight: 'bold',
                                                            backgroundColor: att.status == '0'
                                                                ? '#f8d7da' // Light red for background (Absent)
                                                                : att.status == '1'
                                                                    ? '#d4edda' // Light green for background (Check-in)
                                                                    : att.status == '2'
                                                                        ? '#d1ecf1' // Light blue for background (Check-out)
                                                                        : '#f8f9fa', // Light gray for background (Unrecorded)
                                                            color: att.status == '0'
                                                                ? '#721c24' // Dark red for text (Absent)
                                                                : att.status == '1'
                                                                    ? '#155724' // Dark green for text (Check-in)
                                                                    : att.status == '2'
                                                                        ? '#0c5460' // Dark blue for text (Check-out)
                                                                        : '#6c757d', // Dark gray for text (Unrecorded)
                                                        }}
                                                    >
                                                        {att.status == '0'
                                                            ? 'Absent'
                                                            : att.status == '1'
                                                                ? 'Check-in'
                                                                : att.status == '2'
                                                                    ? 'Check-out'
                                                                    : 'Unrecorded'}
                                                    </div>

                                                ))}
                                            </td>
                                            <td>
                                                <div className="timeline" style={{ position: 'relative', paddingLeft: '20px', borderLeft: '2px solid #28A745' }}>
                                                    {student.attendance
                                                        .filter(att => att.status !== 'unrecorded') // Filter out unrecorded statuses
                                                        .map((att, i) => {
                                                            // Calculate duration
                                                            const duration =
                                                                att.check_in_time && att.check_out_time
                                                                    ? moment
                                                                        .duration(moment.unix(att.check_out_time).diff(moment.unix(att.check_in_time)))
                                                                        .humanize()
                                                                    : null;

                                                            return (
                                                                <div
                                                                    key={i}
                                                                    style={{
                                                                        position: 'relative',
                                                                        marginBottom: '20px',
                                                                        paddingLeft: '20px',
                                                                    }}
                                                                >
                                                                    {/* Timeline Marker */}
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            left: '-28px',
                                                                            top: '0',
                                                                            width: '15px',
                                                                            height: '15px',
                                                                            backgroundColor: '#28A745', // Red color
                                                                            borderRadius: '50%',
                                                                            border: '2px solid white',
                                                                            boxShadow: '0 0 0 2px #28A745',
                                                                        }}
                                                                    ></div>

                                                                    {/* Check-in Time */}
                                                                    {att.check_in_time && (
                                                                        <div style={{ color: '#28A745', fontWeight: 'bold', marginBottom: '5px' }}>
                                                                            Check-in: {moment.unix(att.check_in_time).format('hh:mm A')}
                                                                            <br /> Gate: {att.check_in_gate}
                                                                        </div>
                                                                    )}

                                                                    {/* Check-in Image */}
                                                                    {(att.status == '1' || att.status == '2') && att.check_in_image_url && (
                                                                        <img
                                                                            src={att.check_in_image_url}
                                                                            alt="Check-In"
                                                                            style={{
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                marginTop: '5px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #28A745',
                                                                            }}
                                                                        />
                                                                    )}

                                                                    {/* Check-out Time */}
                                                                    {att.check_out_time && (
                                                                        <div style={{ color: '#28A745', fontWeight: 'bold', marginTop: '10px', marginBottom: '5px' }}>
                                                                            Check-out: {moment.unix(att.check_out_time).format('hh:mm A')}
                                                                            <br /> Gate: {att.check_out_gate}
                                                                        </div>
                                                                    )}

                                                                    {/* Check-out Image */}
                                                                    {att.check_out_image_url && (
                                                                        <img
                                                                            src={att.check_out_image_url}
                                                                            alt="Check-Out"
                                                                            style={{
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                marginTop: '5px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #28A745',
                                                                            }}
                                                                        />
                                                                    )}

                                                                    {/* Duration */}
                                                                    {duration && (
                                                                        <div style={{ color: '#28A745', marginTop: '10px', fontWeight: 'bold' }}>
                                                                            Duration: {duration}
                                                                        </div>
                                                                    )}
                                                                    {/* Remarks */}
                                                                    {att.remarks && (
                                                                        <div style={{ color: '#28A745', marginTop: '10px' }}>
                                                                            <strong>Remarks:</strong> {att.remarks}
                                                                        </div>
                                                                    )}
                                                                    {/* Button for Letter Attachment */}
                                                                    {att.status === '0' && att.letter_attachment_url && (
                                                                        <div style={{ marginTop: '10px' }}>
                                                                            <button
                                                                                style={{
                                                                                    backgroundColor: '#e74c3c',
                                                                                    color: 'white',
                                                                                    border: 'none',
                                                                                    borderRadius: '5px',
                                                                                    padding: '5px 10px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                                onClick={() => window.open(att.letter_attachment_url, '_blank')}
                                                                            >
                                                                                View Letter
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </td>
                                            <td className="align-top">
                                                <div className="d-flex flex-column gap-3">
                                                    {student.attendance.some(att => att.status === 'unrecorded') && (
                                                        <button
                                                            className="btn btn-sm fw-bold text-uppercase"
                                                            style={{
                                                                backgroundColor: '#E94057',
                                                                color: '#fff',
                                                                border: '2px solid #E94057',
                                                                padding: '8px 16px',
                                                                borderRadius: '12px',
                                                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                fontWeight: 'bold',
                                                                transition: 'all 0.3s ease',
                                                            }}
                                                            onClick={() => notifyParent(student.student_uuid)}
                                                        >
                                                            Notify Parent
                                                        </button>
                                                    )}

                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column gap-3">
                                                    <button
                                                        className="btn btn-sm fw-semibold"
                                                        style={{
                                                            backgroundColor: 'white',
                                                            color: '#E94057',
                                                            border: '2px solid #E94057',
                                                            padding: '8px 16px',
                                                            borderRadius: '12px',
                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                            fontWeight: '600',
                                                            transition: 'all 0.3s ease',
                                                        }}
                                                        onClick={() => openRecordAttendanceModal(student)}
                                                    >
                                                        Record Attendance
                                                    </button>
                                                    <button
                                                        className="btn btn-sm fw-semibold"
                                                        style={{
                                                            backgroundColor: 'white',
                                                            color: '#E94057',
                                                            border: '2px solid #E94057',
                                                            padding: '8px 16px',
                                                            borderRadius: '12px',
                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                            fontWeight: '600',
                                                            transition: 'all 0.3s ease',
                                                        }}
                                                        onClick={() => openUpdateClassModal(student)}
                                                    >
                                                        Change Class
                                                    </button>
                                                    <button
                                                        className="btn btn-sm fw-semibold"
                                                        style={{
                                                            background: 'rgba(233,64,87,0.09)',
                                                            color: '#E94057',
                                                            border: '2px solid #E94057',
                                                            padding: '8px 18px',
                                                            borderRadius: '24px',
                                                            fontWeight: 700,
                                                            letterSpacing: '0.02em',
                            
                                                            boxShadow: '0 3px 8px rgba(233,64,87,0.13)',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 7,
                                                            transition: 'all 0.18s',
                                                            backdropFilter: 'blur(3px)',
                                                            cursor: (student.student_status === '2'  || student.student_status === '3'|| student.student_status === '4') ? 'pointer' : 'not-allowed',
                                                            opacity: (student.student_status === '2'  || student.student_status === '3' || student.student_status === '4') ? 1 : 0.45,
                                                        }}
                                                        onClick={() => openDeleteModal(student)}
                                                        disabled={!(student.student_status === '2'  || student.student_status === '3' || student.student_status === '4')}
                                                        onMouseOver={e => {
                                                            if (student.student_status === '2' || student.student_status === '3'|| student.student_status === '4') {
                                                                e.currentTarget.style.background = 'linear-gradient(90deg, #E94057 0%, #F27121 100%)';
                                                                e.currentTarget.style.color = 'white';
                                                            }
                                                        }}
                                                        onMouseOut={e => {
                                                            if (student.student_status === '2' ||student.student_status === '3' || student.student_status === '4') {
                                                                e.currentTarget.style.background = 'rgba(233,64,87,0.09)';
                                                                e.currentTarget.style.color = '#E94057';
                                                            }
                                                        }}
                                                    >
                                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"
                                                            strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 3 }} viewBox="0 0 24 24">
                                                            <polyline points="3 6 5 6 21 6" />
                                                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                                                            <line x1="10" y1="11" x2="10" y2="17" />
                                                            <line x1="14" y1="11" x2="14" y2="17" />
                                                        </svg>
                                                        Delete Student
                                                    </button>

                                                </div>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                        ) : (
                            <p>Loading</p>
                        )}
                    </div>
                </div>
                {/* Modal for Updating Class */}
                <Modal isOpen={modalOpen} toggle={closeModal}>
                    <ModalHeader toggle={closeModal}>Update Student's Class</ModalHeader>
                    <ModalBody>
                        <select
                            className="form-control"
                            value={newClassId}
                            onChange={(e) => setNewClassId(e.target.value)}
                        >
                            <option value="">Select a new class</option>
                            {allClasses.map((cls) => (
                                <option key={cls.class_id} value={cls.class_id}>
                                    {cls.class_name}
                                </option>
                            ))}
                        </select>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={updateStudentClass}>Update</Button>
                        <Button color="secondary" onClick={closeModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={nameModalOpen} toggle={closeNameModal}>
                    <ModalHeader toggle={closeNameModal}>Update Student's Name</ModalHeader>
                    <ModalBody>
                        <input
                            type="text"
                            className="form-control"
                            value={newStudentName}
                            onChange={(e) => setNewStudentName(e.target.value)}
                            placeholder="Enter new student name"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={updateStudentName}>Update</Button>
                        <Button color="secondary" onClick={closeNameModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={recordModalOpen} toggle={() => setRecordModalOpen(false)}>
                    <ModalHeader toggle={() => setRecordModalOpen(false)}>
                        Manual Attendance Entry
                    </ModalHeader>
                    <ModalBody>
                        {selectedStudent && (
                            <div className="mb-3 p-3 text-black rounded bg-light border">
                                <h5 className="mb-1">{selectedStudent.first_name}</h5>
                                {selectedStudent.moeis_name && selectedStudent.moeis_name !== selectedStudent.first_name && (
                                    <small className="text-muted">MOEIS Name: {selectedStudent.moeis_name}</small>
                                )}
                            </div>
                        )}

                        <div className="form-group">
                            <label>Start Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={recordStartDate}
                                onChange={(e) => setRecordStartDate(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <label>End Date (optional)</label>
                            <input
                                type="date"
                                className="form-control"
                                value={recordEndDate}
                                onChange={(e) => setRecordEndDate(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <label>Status</label>
                            <select
                                className="form-control"
                                value={recordStatus}
                                onChange={(e) => setRecordStatus(e.target.value)}
                            >
                                <option value={0}>Absent</option>
                                <option value={1}>Present</option>
                            </select>
                        </div>
                        {recordStatus == 0 ? <div className="form-group">
                            <label>MC/Absence Reason</label>
                            <select
                                className="form-control"
                                value={selectedMCReason?.value || ""}
                                onChange={e => {
                                    const selected = mcReasons.find(r => String(r.value) === e.target.value);
                                    setSelectedMCReason(selected || null);
                                }}
                            >
                                <option value="">-- Select Reason --</option>
                                {mcReasons.map(r => (
                                    <option key={r.value} value={r.value}>
                                        {r.label}
                                    </option>
                                ))}
                            </select>

                        </div> : null}
                        {recordStatus != 0 ? <div className="form-group">
                            <label>Remarks</label>
                            <input
                                type="text"
                                className="form-control"
                                value={recordRemarks}
                                onChange={(e) => setRecordRemarks(e.target.value)}
                            />
                        </div> : null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={submitManualAttendance}>Submit</Button>
                        <Button color="secondary" onClick={() => setRecordModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={deleteModalOpen} toggle={closeDeleteModal}>
                    <ModalHeader toggle={closeDeleteModal}>Confirm Delete</ModalHeader>
                    <ModalBody>
                        {studentToDelete && (
                            <div>
                                Are you sure you want to <b>delete</b> the student "<b>{studentToDelete.first_name}</b>"? <br />
                                This action <b>cannot be undone</b>.
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="danger"
                            onClick={confirmDeleteStudent}
                            disabled={deleting}
                            style={{
                                minWidth: 120,
                                fontWeight: 700,
                                boxShadow: '0 2px 10px #e9405755',
                                background: 'linear-gradient(90deg, #E94057 0%, #F27121 100%)',
                                border: 'none',
                                borderRadius: '30px',
                                fontSize: '1rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 8,
                                opacity: deleting ? 0.7 : 1,
                                transition: 'all 0.2s'
                            }}
                        >
                            {deleting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    Deleting...
                                </>
                            ) : (
                                <>Delete</>
                            )}
                        </Button>

                        <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>

            </div>
        </Fragment>
    );
};

export default ClassProfile;
